import React from "react";
import { navigate } from "utils/routes";
import { Alert } from ".";

export const PreviewAlertBox = () => (
  <Alert
    level="info"
    message="This is a preview mode. To exit close this alert box!"
    handlingStrategy="closeable"
    onClose={() =>
      navigate(`/api/exit-preview?redirectTo=${window.location.origin}`)
    }
  />
);
